import React from 'react'
import ExpertHero from '../components/expertisepage/ExpertHero'
import Technicals from '../components/expertisepage/Technicals'
import Design from '../components/expertisepage/Design'
import OpHero from '../components/expertisepage/OpHero'
import Operationals from '../components/expertisepage/Operational'
import Languages from '../components/expertisepage/Languages'

function Expertise() {
  return (
    <>
      <ExpertHero/>
      <Technicals/>
      <Design/>
      <OpHero/>
      <Operationals/>
      <Languages/>
    </>
  )
}

export default Expertise